import React from "react";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Fade from '@mui/material/Fade';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function SnackbarMsg(props) {
    return (
        <Snackbar open={props.showError} autoHideDuration={6000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} onClose={props.onClose}
            TransitionComponent={Fade}>
            <Alert onClose={props.onClose} severity={props.severity}>
                {props.msg}
            </Alert>
        </Snackbar>
    )

}